import React, { useState } from 'react';
import { ChevronDown, MessageCircleQuestion } from 'lucide-react';
import { Card } from '@/components/ui';
import { cn } from '@/utils/cn';
import { useFAQs, FAQ } from '../hooks/useFAQs';

export function FAQAccordion() {
  const { data: faqs = [], isLoading } = useFAQs();
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  if (isLoading) {
    return (
      <Card className="p-6 border-slate-100 shadow-sm animate-pulse space-y-4">
        {[1, 2, 3].map(i => (
          <div key={i} className="h-12 bg-slate-100 rounded-md"></div>
        ))}
      </Card>
    );
  }

  return (
    <Card className="p-6 border-slate-100 shadow-sm bg-white">
      <h3 className="sm:text-sm text-xs font-semibold text-slate-900 mb-6 flex items-center gap-2">
        <MessageCircleQuestion className="w-4 h-4 text-emerald-600" />
        Câu hỏi thường gặp
      </h3>

      <div className="space-y-3">
        {faqs.map((faq) => (
          <div 
            key={faq.id} 
            className={cn(
              "border border-slate-100 rounded-lg overflow-hidden transition-colors",
              openId === faq.id ? "bg-slate-50/50" : "bg-white hover:bg-slate-50"
            )}
          >
            <button
              onClick={() => toggle(faq.id)}
              className="w-full text-left px-4 py-3.5 flex items-center justify-between gap-4"
            >
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-[10px] px-2 py-0.5 bg-slate-100 text-slate-600 rounded whitespace-nowrap w-fit">
                  {faq.category}
                </span>
                <span className="sm:text-sm text-xs font-medium text-slate-800">
                  {faq.question}
                </span>
              </div>
              <ChevronDown 
                size={16} 
                className={cn("text-slate-400 transition-transform duration-200 shrink-0", openId === faq.id ? "rotate-180" : "")} 
              />
            </button>
            
            <div 
              className={cn(
                "overflow-hidden transition-all duration-200",
                openId === faq.id ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
              )}
            >
              <div className="px-4 pb-4 sm:text-sm text-xs text-slate-600 leading-relaxed border-t border-slate-100/50 pt-3">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
